import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { CompanyLogos } from './components/CompanyLogos';
import { CurriculumSection } from './components/CurriculumSection';
import { MentorsSection } from './components/MentorsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { OnboardingFlow } from './components/OnboardingFlow';
import { useOnboarding } from './hooks/useOnboarding';
export function App() {
  const onboarding = useOnboarding();
  return <div className="min-h-screen bg-dark-900 relative overflow-x-hidden" data-id="element-0">
      {/* Global grid overlay */}
      <div className="fixed inset-0 pointer-events-none" style={{
      zIndex: 9999
    }} data-id="element-1">
        {/* Fine 24px grid */}
        <div className="absolute inset-0" style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.015) 1px, transparent 1px)`,
        backgroundSize: '24px 24px'
      }} data-id="element-2" />
        {/* Larger 120px accent grid for depth layering */}
        <div className="absolute inset-0" style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)`,
        backgroundSize: '120px 120px'
      }} data-id="element-3" />
        {/* Radial vignette — stronger fade toward edges */}
        <div className="absolute inset-0" style={{
        background: `radial-gradient(ellipse 60% 50% at 50% 50%, transparent 20%, rgba(10,10,10,0.85) 100%)`
      }} data-id="element-4" />
      </div>

      <OnboardingFlow isOpen={onboarding.isOpen} onClose={onboarding.closeOnboarding} hook={onboarding} data-id="element-5" />

      <Navbar onOpenOnboarding={onboarding.openOnboarding} data-id="element-6" />
      <main data-id="element-7">
        <HeroSection onOpenOnboarding={onboarding.openOnboarding} data-id="element-8" />
        <CompanyLogos data-id="element-9" />
        <FeaturesSection data-id="element-10" />
        <CurriculumSection data-id="element-11" />
        <MentorsSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <PricingSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <CTASection onOpenOnboarding={onboarding.openOnboarding} data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}